import { Helmet } from 'react-helmet-async';

const schema = {
  '@context': 'https://schema.org',
  '@type': 'LocalBusiness',
  name: '트라이그라운드 스튜디오',
  alternateName: 'Tryground Studio',
  image: 'https://trygroundstudio.com/img/sofa-space-01.png',
  url: 'https://trygroundstudio.com',
  telephone: '+82-70-4422-8060',
  email: 'service@tryground.co.kr',
  priceRange: '₩19,000 - ₩39,000',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '낙성대역4길 3, 4층',
    addressLocality: '관악구',
    addressRegion: '서울특별시',
    addressCountry: 'KR',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 37.475426,
    longitude: 126.961626,
  },
  hasMap: 'https://naver.me/xAtWIxJ9',
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ],
    opens: '09:00',
    closes: '23:59',
  },
  areaServed: '서울특별시 관악구',
};

function LocalBusinessSchema() {
  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
}

export default LocalBusinessSchema;
